"use client";
import { createContext } from "react";
//#region src/group/group-label-context.tsx
const GroupLabelContext = createContext(void 0);
//#endregion
export { GroupLabelContext };

//# sourceMappingURL=group-label-context.js.map